import * as RadixToggle from '@radix-ui/react-toggle';
import classNames from 'classnames';
import type { PropsWithChildren, ReactElement } from 'react';
import React from 'react';
import type { ToggleProps } from 'types/props/toggle';
import type PropsWithClassname from 'types/props-with-classname';
import { validateString } from 'utils/validate-string';

import styles from './toggle.module.scss';

export interface Props
  extends PropsWithChildren,
    PropsWithClassname,
    ToggleProps {
  readonly className?: string;
}

const rootClass = validateString(styles.root);

function Toggle({ className, children, ...toggleProps }: Props): ReactElement {
  return (
    <RadixToggle.Root
      className={classNames(rootClass, className)}
      {...toggleProps}
    >
      {children}
    </RadixToggle.Root>
  );
}

export default Toggle;
